import React from "react";

import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import infoIcon from "./Icons/info3.svg";
import ReactHtmlParser from "react-html-parser";

const ToolTip = ({ data, icon, image, text, disabled, isEmailTooltip = false, parentClassName = "", className = "" }) => {
	return (
		<span className={`customTip mr-1 ${parentClassName}`}>
			<Tippy
				animation={true}
				theme="custom"
				content={
					typeof data === "string" ? ReactHtmlParser(data) : data
				}
				placement="bottom"
				disabled={disabled ? disabled : false}
				arrow={true}
				className="custom-tippy">
				{/* Tooltip icon */}
				<i className={`ml-1 ${className}`}>
					{text ? (
						text
					) : image ? (
						<img src={image} />
					) : icon ? (
						<i className={icon}></i>
					) : (
						<>
							<img className="infocus" src={infoIcon}></img>
						</>
					)}
				</i>
			</Tippy>
			<style jsx global>{`
				.infocus {
					max-width: 15px;
					max-height: 18px;
					padding-bottom: ${isEmailTooltip ? "0px" : "3px"}!important;
				}

				.tippy-tooltip {
					font-size: 30px;
					padding: 0.3rem 0.6rem;
				}
				.widget-font-normal{
					font-style : normal !important;
				}

			`}</style>
		</span>
	);
};

export default ToolTip;
